import { Box, SxProps } from '@mui/material';

import PGX from '../../../assets/PGXIcon.png';

export const PgxIcon = ({ sx }: { sx?: SxProps }) => {
  return (
    <Box
      component="img"
      sx={{
        width: 30,
        height: 30,
        display: 'inline-block',
        ...sx,
      }}
      src={PGX}
      alt=""
    />
  );
};
